import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { OpeningWrapper } from '../../legacyCore/OpeningsCalendar';
import { formatOpeningTime } from '../utils/formatCalendarTime';
import getTimeZoneFormat from '../utils/getTimeZoneFormat';
import toDate from '../utils/toDate';
import { buildOpeningUrl } from '../utils/urls';
import WidgetLink from './WidgetLink';

export default function CalendarOpening(props) {
  const intl = useIntl();
  const location = useLocation();
  const { opening, timeZone, staticContext, ...linkProps } = props;

  const openingUrl = buildOpeningUrl(opening.provider.id, opening.id, {
    location,
  });

  const dateTime = toDate(opening.time);
  const timeZoneFormat = getTimeZoneFormat(timeZone);

  return (
    <OpeningWrapper>
      <WidgetLink
        {...linkProps}
        href={openingUrl}
        toWidget={linkProps.isOnWidget}
        data-qa="calendar-table__opening"
      >
        <time>{formatOpeningTime(dateTime, intl, timeZoneFormat)}</time>
      </WidgetLink>
    </OpeningWrapper>
  );
}
